<input type="checkbox" #inputBox id="toggle-button-checkbox" [checked]="isChecked" (change)="onChange($event)" >
<label class="toggle-button-switch"  for="toggle-button-checkbox"></label>
<div class="toggle-button-text">
    <div class="toggle-button-text-on">&nbsp;</div>
    <div class="toggle-button-text-off">&nbsp;</div>
</div>
